import React, { useContext } from 'react'
import { useQuery } from '@apollo/client'
import { Select } from 'antd'
import { INTERNAL_MANAGERS_QUERY } from '../../../../graphql/User'
import CentredLoader from '../../../../components/CentredLoader'
import { SelectedUserContext } from '../../contexts/selectedUserContext'
import Metrics from './Metrics'

const UserSection = (): JSX.Element => {
  const { selectedUser, setSelectedUser, canFullAccess } =
    useContext(SelectedUserContext)

  const { data, loading } = useQuery(INTERNAL_MANAGERS_QUERY)

  const { Option } = Select

  if (loading) return <CentredLoader />

  return (
    <>
      {selectedUser && <Metrics selectedUser={selectedUser} />}
      <Select
        allowClear={canFullAccess}
        style={{ width: 250 }}
        onChange={(e: number) => setSelectedUser(e)}
        defaultValue={selectedUser}
        placeholder={'Manager'}
      >
        {data.internalManagers.map((internal_manager: any) => (
          <Option key={internal_manager.id} value={internal_manager.id}>
            {internal_manager.email}
          </Option>
        ))}
      </Select>
    </>
  )
}

export default UserSection
